import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
import { Endpoints } from "../../Global/Endpoints";
import { useTranslation } from 'react-i18next';
import ChatBotWindow from "../ChatBot/ChatBotWindow";
import { useChat } from '../Layout/ChatContext';

const WINBenefit_LandingPage = () => {
    const { t } = useTranslation();
    const [benefitOptions, setBenefitOptions] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true); // Add loading state
    const contract = useSelector((state) => state.userData);
    const [feedLinks, setFeedLinks] = useState(""); // State for feed links
    const token = localStorage.getItem("AccessToken");
    const navigate = useNavigate();
    const API_URL = Endpoints.UnderstandingBenefits;
    const [memberReqAuth, setMemberReqAuth] = useState(""); // Store MemberReqAuth
    const [ucReqAuth, setUcReqAuth] = useState(""); // Store MemberReqAuth
    const payload = {
        _Params: JSON.stringify({ EmailID: contract.userData.EmailID, MemberID:contract.userData.MemberID, DeviceType: "PatientPortal" }),
    };
    const { isChatVisible } = useChat();
    const ssoData = useSelector((state) => state.sso.ssoUserData);
    const isHighmarkPortal = ssoData?.Portal === "Highmark";

    useEffect(() => {
        const fetchBenefits = async () => {
            try {
                const response = await axios.post(API_URL, payload, {
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        Authorization: `Bearer ${token}`,
                    },
                });

                // Gopi
                const data = response.data;
                console.log(response.data);
                setFeedLinks(data.BenefitsOverview || ""); // Set the feed link in state
                setMemberReqAuth(data.MemberReqAuth || "");
                setUcReqAuth(data.UCHealthAuth || "");
                // Define benefit options based on provided conditions
                const options = [
                    { label: t("benefitdetails"), value: data.BenefitsOverview, condition: data.BenefitDetails === "Y" }, // For everyone
                    { label: t("benefitaccumulator"), value: data.BenefitAccumulator, condition: data.BenefitAccumulator === "Y" }, // Premier
                    { label: t("treatmentauthheading"), value: data.TreatmentAuthorization, condition: data.TreatmentAuthorization === "Yes", route: "/treatment-authorization" }, // Redirect to /treatment-authorization
                    { label: t("mydocuments"), value: data.MyDocuments, condition: data.MyDocuments === "Y", route: "/benefits-mydocuments" }, // For everyone
                    { label: t("rxAuthorization"), value: data.ReviewRx, condition: data.ReviewRx === "Yes" , route: "/rx-authorization" }, // Redirect to /rx-authorization
                    { label: t("patientid"), value: data.PatientID, condition: data.PatientID === "Y", route: "/benefit-patientid" }, // Premier
                    { label: t("phiform"), value: data.PHIForm, condition: data.PHIForm === "Y", route: "/benefits-phiform" }, // AppRegistered Yes
                    {
                        label: isHighmarkPortal ? "Fertility and Family Building Pay" : t("winpaytitle"),
                        value: data.WINPay,
                        condition: data.WINPay === "Yes",
                        route: isHighmarkPortal ? "/pay-landingpage" : "/winpay-landingpage"
                    },
                    { label: t("treatmentcostaccumulator"), value: data.TreatmentCostEstimator, condition: data.TreatmentCostEstimator === "Y" }, // Premier
                ].filter((option) => {
                    // Exclude Patient ID tile if Highmark
                    if (isHighmarkPortal && option.label === t("patientid")) {
                        return false;
                    }
                    return option.condition;
                }); // Filter based on conditions
                setBenefitOptions(options);
            } catch (error) {
                setError(t("failedtofetchdocuments"));
            } finally {
                setLoading(false); // Set loading to false after data fetching
            }
        };

        fetchBenefits();
    }, []);

    const handleButtonClick = async (label, value, route) => {
        if (label === t("patientid")) {
            try {
                const formattedActivity = "ID Card";
                const payload = `_Params=${encodeURIComponent(
                    JSON.stringify({
                        EmailID: contract.userData.EmailID,
                        Activity: formattedActivity,
                        DeviceType: "PatientPortal",
                    })
                )}`;

                const response = await axios.post(
                    Endpoints.CallRecoderLog,
                    payload,
                    {
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded",
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                if (response.status === 200) {
                    navigate(route); // Navigate to Patient ID route
                }
            } catch (error) {
               return;
            }
        } else if (label === t("benefitdetails") && feedLinks) {
            try {
                const formattedActivity = `My Benefits:${feedLinks}`;
                const payload = `_Params=${encodeURIComponent(
                    JSON.stringify({
                        EmailID: contract.userData.EmailID,
                        Activity: formattedActivity,
                        DeviceType: "PatientPortal",
                    })
                )}`;

                const response = await axios.post(
                    Endpoints.CallRecoderLog,
                    payload,
                    {
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded",
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                if (response.status === 200) {
                    navigate("/benefit-details", { state: { feedLink: feedLinks, apiResponse: response.data } });
                }
            } catch (error) {
                return;
            }
        } 
        else if(label===t('benefitaccumulator'))
        {
            navigate("/benefits-accumulator") 
        }
        else if(label===t('treatmentcostaccumulator'))
        {
            navigate("/benefits-treatmentcostestimator") 
        }
        else if(label==="Treatment Authorization")
        {
            navigate("/treatment-authorization", { state: { memberReqAuth, Benifit: "Benifit",ucReqAuth } });
        }
        else if(label==="WINPay")
        {
            navigate("/pay-landingpage",{ state: { memberReqAuth, Benifit: "Benifit" } });
        }
        else if (route) {
            navigate(route);
        } else if (value && value.startsWith("http")) {
            window.open(value, "_blank");
        } else {
            console.log(`No action defined for ${label}`);
        }
    };

    const handleBackClick = () => {
        navigate("/home"); 
      };

    if (loading) {
        return (
            <div className="loading-container">
                <div className="loading"></div>
                <h2 className="loading-text">{t("loading")}</h2>
            </div>
        );
    }

    return (
        <>
            <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
                <button className="win-back-btn me-1" onClick={handleBackClick}>
                    <span>
                        <i className="bi bi-chevron-left"></i> {t("back")}
                    </span>
                </button>
                <h2 className="page-heading">{t("mybenefits")}</h2>
            </div>
            {error ? (
                <p style={{ color: "red", textAlign: "center" }}>{error}</p>
            ) : benefitOptions.length === 0 ? (
                <p className="no-data-available">
                    {t("noBenefitsAvailable")}
                </p>
            ) : (
                <div className="find-provider-wrapper">
                    {benefitOptions.map((option, index) => (
                        <div
                            key={index}
                            onClick={() => handleButtonClick(option.label, option.value, option.route)}
                            className="schedule-block support-services-highmark"
                        >
                            <span className="schedule-block-left-logo"></span>
                            <div className="service-content find-provider">
                                <h4>{option.label}</h4>
                            </div>
                        </div>
                    ))}
                </div>
            )}
            {/* {isChatVisible && <ChatBotWindow />} */}
        </>
    );
};

export default WINBenefit_LandingPage;
